import { render, staticRenderFns } from "./ebs-register.vue?vue&type=template&id=9eb1ad7e&"
import script from "./ebs-register.vue?vue&type=script&lang=js&"
export * from "./ebs-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports